import { get, includes } from 'lodash';

import { UserBase } from '@lib/resources/types';

interface User extends Partial<UserBase> {
  _id?: string;
}

export function isAdmin(user?: User) {
  return includes(get(user, 'roles'), 'admin');
}

export function isManager(user?: User) {
  return includes(get(user, 'roles'), 'manager');
}

export function isMaster(user?: User) {
  return user && user._id === user.user;
}
